import * as React from 'react';
import styled from 'styled-components';
import { desktop } from '../BreakPoints';
import { Flex } from '../compositeComponents/FlexHelpers';

type RadioButtonProps = {
    id?:string,
    name:string,
    text:string,
    value:string,
    checked:boolean,
    disabled?:boolean,
    onChange:(value:string)=>void
}

export function RadioButton(props:RadioButtonProps)
{
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>)=>{
        props.onChange(e.currentTarget.value);
    };

    return (
        <Flex flexDirection="row" alignItems='center'>
            <input 
                type="radio"
                id={props.id}
                name={props.name} 
                value={props.value} 
                checked={props.checked===true ? true : false}
                disabled={props.disabled}
                onChange={handleChange} />
            <label htmlFor={props.id}>{props.text}</label>
        </Flex>
    );
}

export type RadioButtonOption = { text:string, value:string };
export type RadioButtonListProps = {
    groupName:string,
    disabled?:boolean,
    options:RadioButtonOption[],
    selectedValue:string,
    onChange:(selectedValue:string)=>void,
    flexDirection?: 'column' | 'row',
    justifyContent?:string,
    gap?:number
}
export function RadioButtonList(props:RadioButtonListProps)
{
    return (
        <>
            {props.options && props.options.length > 0 &&
                <RadioButtonUnorderedList flexDirection={props.flexDirection} justifyContent={props.justifyContent} gap={props.gap}>
                    {props.options.map((o,i) => {
                        return (
                            <li key={i}>
                                <RadioButton
                                    name={props.groupName}
                                    id={"radio_"+i}
                                    text={o.text}
                                    value={o.value}
                                    checked={o.value === props.selectedValue}
                                    disabled={props.disabled}
                                    onChange={props.onChange}
                                />
                            </li>
                        );
                    })}
                </RadioButtonUnorderedList>
            }
        </>
    );
}

const RadioButtonUnorderedList = styled.ul<{
    flexDirection?: 'column' | 'row',
    justifyContent:string,
    gap?:number
}>`
    list-style-type: none;
    padding: 0px;
    margin-top:5px;
    margin-right:5px;
    display:flex;
    flex-direction:${props => props.flexDirection===undefined ? 'column' : props.flexDirection};
    justify-content:${props => props.justifyContent===undefined ? 'flex-start' : props.justifyContent};
    gap:${props => props.gap===undefined ? 0 : props.gap}px;
    
    @media (max-width: ${desktop}px) {
        
    }

`;